export const loginTypeOptions = {
  0: 'consultant',
  1: 'crm_only'
}

export const publishStatusOptions = [
  {
    label: 'Not Publish',
    value: 0
  },
  {
    label: 'Published',
    value: 1
  }
]

export const statusOptions = [
  {
    label: 'All',
    value: ''
  },
  {
    label: 'In-active',
    value: '0'
  },
  {
    label: 'Active',
    value: '1'
  }
]

export const activeStatusOptions = [
  {
    label: 'InActive',
    value: 0
  },
  {
    label: 'Active',
    value: 1
  }
]
